import React from 'react'
import {Alert, Col, Row} from 'antd'
import { URL_SHOWCASE_PUBLISH } from '../../const'
import { useRouter } from './UseRouter'
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

export default function ShowcasePreviewLayout(props) {
  const router = useRouter(props)
  const {xs} = useBreakpoint();

  return (
    <div style={{ overflowX: 'hidden' }}>
      <Row>
        <Col span={24} style={{ display: 'flex', flexDirection: 'row', height: 64, alignItems: 'center' }}>
          <div
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              fontSize: '1.25rem',
              lineHeight: '1.75rem',
              letterSpacing: '.25px',
              fontWeight: '600'
            }}
          >
            Showcase preview
          </div>
        </Col>
        <Col span={24} style={{}}>
          <button
            style={{
              background: 'none',
              border: 'none',
              boxShadow: 'rgb(40 44 53 / 6%) 0px 4px 8px 0px, rgb(40 44 53 / 6%) 0px 2px 2px 0px',
              color: 'rgb(54, 89, 227)',
              display: 'block',
              padding: '0.75em 1em',
              width: '100%',
              fontSize: '1rem',
              lineHeight: '1.5rem',
              fontWeight: '600',
              cursor: 'pointer',
              backgroundColor: 'rgb(239, 239, 239)'
            }}
            onClick={() => {
              router.push(URL_SHOWCASE_PUBLISH)
            }}
          >
            Close preview
          </button>
        </Col>
      </Row>
        {xs && (
            <Alert
              message="Warning"
              description="Please note that the preview may appear differently on different devices or screen sizes.
              However, the content and information provided should remain the same regardless of the device or screen size."
              type="warning"
              showIcon
              closable
            />
        )}
      <div style={{ padding: xs? 0:32, paddingLeft: xs? 4:'15vw', paddingRight: xs? 4:'15vw' }}>{props.children}</div>
    </div>
  )
}
